import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, FileText, FolderKanban, DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const cards = [
    { icon: FileText, label: 'Edit Content', path: '/admin/content', color: 'cyan' },
    { icon: FolderKanban, label: 'Manage Projects', path: '/admin/projects', color: 'blue' },
    { icon: BarChart3, label: 'Manage Services', path: '/admin/services', color: 'violet' },
    { icon: DollarSign, label: 'Update Pricing', path: '/admin/pricing', color: 'cyan' }
  ];

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-white mb-2">Dashboard</h1>
        <p className="text-gray-400">Manage your portfolio content</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((card, index) => {
          const Icon = card.icon;
          return (
            <Link key={card.path} to={card.path}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -4, scale: 1.02 }}
                className="p-6 bg-gradient-to-br from-[#1a1a1b] to-[#0f0f10] rounded-xl border border-cyan-500/10 hover:border-cyan-500/30 transition-all cursor-pointer group"
              >
                <div className={`w-12 h-12 rounded-lg bg-${card.color}-500/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-6 h-6 text-${card.color}-400`} />
                </div>
                <h3 className="text-lg font-semibold text-white group-hover:text-cyan-400 transition-colors">
                  {card.label}
                </h3>
              </motion.div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default AdminDashboard;
